import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const MoneyIcon = props => {
  return (
    <Svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path d="M15.5 12a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z" fill="#001533" />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.441 6.674a4.71 4.71 0 00-3.84-2.839l-.652-.068a44.4 44.4 0 00-9.9.068l-.433.051a3.681 3.681 0 00-3.213 3.169 37.391 37.391 0 000 9.89 3.681 3.681 0 003.214 3.169l.431.051c3.288.392 6.608.415 9.9.069l.653-.07a4.71 4.71 0 003.84-2.838 2.77 2.77 0 001.963-2.324c.233-1.994.233-4.01 0-6.004a2.77 2.77 0 00-1.963-2.324zm-4.65-1.415a42.9 42.9 0 00-9.565.065l-.432.052A2.181 2.181 0 003.89 7.253a35.89 35.89 0 000 9.494c.132.987.915 1.76 1.904 1.878l.432.05c3.176.38 6.385.401 9.566.067l.652-.069a3.207 3.207 0 002.124-1.13 26.873 26.873 0 01-4.526-.119 2.772 2.772 0 01-2.446-2.421 25.846 25.846 0 010-6.005 2.772 2.772 0 012.446-2.422 26.863 26.863 0 014.526-.118 3.207 3.207 0 00-2.124-1.13l-.652-.07zm3.486 2.756l.002.011.006.04.199-.032c.103.01.205.021.308.033.587.065 1.055.53 1.122 1.105.22 1.879.22 3.777 0 5.656a1.273 1.273 0 01-1.122 1.106l-.308.032-.199-.031-.006.039-.002.011a25.37 25.37 0 01-5.069-.051 1.273 1.273 0 01-1.122-1.106c-.22-1.879-.22-3.777 0-5.656a1.272 1.272 0 011.122-1.105 25.372 25.372 0 015.07-.052z"
        fill="#001533"
      />
    </Svg>
  );
};

export default MoneyIcon;
